<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>群聊信息管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form  :inline="true">
        <el-form-item label="搜索：">
				<el-popover  v-model="visible">
                    <!-- <el-tooltip content="" placement=""> -->
					<el-input class="cp" readonly slot="reference" style="width: 230px;" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
					<!-- </el-tooltip> -->
					<el-tree :data="deptData"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
						<span class="custom-tree-node" slot-scope="{  data }">
							<span>
								<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
								<i v-if="data.parentId"  class="el-icon-location-outline"></i>
								<i v-if="data.isJz"  class="el-icon-coin"></i>
								{{ data.departmentName }}
							</span>
						</span>
					</el-tree>
				</el-popover>
            </el-form-item>
            <el-form-item label="">
               <el-input v-model="tableParam.groupName" size="small" placeholder="群聊名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="search" type="primary"  icon="el-icon-search" size="small">搜索</el-button>
                <!-- <el-button @click="handleExportRecord" :loading="downloadLoadin" type="success"  icon="el-icon-download" size="small">导出</el-button> -->
                <prems-button size="small" type="primary"  perms="message:addGroupChat" icon="el-icon-circle-plus-outline" @click="handleGroupChat" label="添加" />
            </el-form-item>
           
        </el-form>
        <!-- 表格 -->
        <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
            style="width: 100%;" stripe :max-height="tableHeight"  :header-cell-style="this.$store.state.headerCss">
            <el-table-column align="center" type="index" width="60" label="序号">
            </el-table-column>
            <el-table-column prop="groupName" label="群聊名称" sortable align="center">
            </el-table-column>
            <el-table-column prop="sendMessageUrl" label="群聊地址" sortable align="center">
            </el-table-column>
            <el-table-column prop="isEnabled" label="启用" sortable align="center">
                <template slot-scope="scope">
                    <el-tag size="small" type="success" v-if="scope.row.isEnabled">是</el-tag>
                    <el-tag size="small" type="danger" v-if="!scope.row.isEnabled">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="updateDate" label="更新时间" sortable align="center">
            </el-table-column>
            <el-table-column prop="isSuccess" label="操作" sortable align="center">
                  <template slot-scope="scope">
                    <prems-button size="small" type="warning" perms="message:setGroupChat" icon="el-icon-s-tools" @click="setGroupChat(scope.row)" label="设置" />
                    <prems-button size="small" type="primary"  perms="message:editGroupChat" icon="el-icon-edit" @click="handleGroupChat(scope.row,'edit')" label="编辑" />
                    <prems-button size="small" type="danger"  perms="message:deleteGroupChat" icon="el-icon-delete" @click="deleteGroupChat(scope.row)" label="删除" />
              </template>
            </el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="tableParam" @callFather="handelPage" v-if="showPage"></Pagination>

        <!-- 2023。11.22 添加编辑 -->
      <el-dialog :title="addTitle" :visible.sync="formVisible" width="25%" :close-on-click-modal="false">
          <el-form  :model="addParam"  ref="editForm" :rules="rules" label-width="100px">
              <el-form-item prop="groupName" label="群聊名称：">
                <el-input size="small"  placeholder="群聊名称" v-model="addParam.groupName" ></el-input>
              </el-form-item>
              <el-form-item prop="sendMessageUrl" label="发送地址：">
                <el-input size="small" placeholder="发送地址" v-model="addParam.sendMessageUrl"></el-input>
              </el-form-item>
              <el-form-item label="启用：">
                <el-radio-group v-model="addParam.isEnabled">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="formVisible = false">取消</el-button>
              <el-button size="small" type="primary" :loading="saveLoading" class="title" @click="saveAddOrEdit">保存</el-button>
          </div>
      </el-dialog>

       <!-- 2023.11.20 绑定群聊信息 -->
       <el-dialog title="绑定预警信息" :visible.sync="bindFormVisible" width="45%"  :close-on-click-modal="false">
          <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddGroupChat" icon="el-icon-circle-plus-outline">添加</el-button>
          <el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindGroupChat" icon="el-icon-delete" :loading="unbindLoading" :disabled="!selectGroupList.length" >删除</el-button>
          <div style="line-height: 30px;">当前绑定的预警阈值</div>
          <el-table size="small" :data="bindGroupChatList"  :header-cell-style="this.$store.state.headerCss" max-height="500px" border 
          v-loading="loadBindGroupChat" @selection-change="selectUnbind" element-loading-text="拼命加载中">
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="id" prop="id" width="100"  align="center"></el-table-column>
              <el-table-column label="预警名称" prop="alarmName"  align="center"></el-table-column>
              <el-table-column label="阀值" prop="threshold"  align="center"></el-table-column>
              <el-table-column label="创建时间" prop="createDate"  align="center"></el-table-column>
          </el-table>
          <div style="line-height: 40px;">共计:{{bindGroupChatList.length}}</div>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click='bindFormVisible = false'>关闭</el-button>
              <!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
          </div>
      </el-dialog>

      <!-- 2023.11.20 选择群聊绑定 -->
      <el-dialog title="选择预警信息绑定" :visible.sync="groupChatVisible" width="45%" :close-on-click-modal="false">
        <el-form  :inline="true">
  
          <el-form-item >
            <el-input style="width: 100%;" size="small"  v-model="bindUrlParams.alarmName" placeholder="请输入预警名称"></el-input>
          </el-form-item>
          <el-form-item >
            <el-button size="small" type="primary" @click="getAllGroupChatList">搜索</el-button>
          </el-form-item>
        </el-form>
          <el-table size="small" v-loading="allgroupLoad" :data="allGroupChatList"  :header-cell-style="this.$store.state.headerCss" 
          max-height="500px" border  @selection-change="getUrlIds" element-loading-text="拼命加载中">
              <el-table-column type="selection" align="center"></el-table-column>
              <el-table-column label="id" prop="id" width="100"  align="center"></el-table-column>
              <el-table-column label="预警名称" prop="alarmName"  align="center"></el-table-column>
              <el-table-column label="阀值" prop="threshold"  align="center"></el-table-column>
              <el-table-column label="创建时间" prop="createDate"  align="center"></el-table-column>
  
          </el-table>
          <div style="line-height: 40px;">共计:{{allGroupChatList.length}}</div>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click='groupChatVisible = false'>取消</el-button>
              <el-button size="small" type="primary" :loading="saveBindLoading" class="title" @click="saveBindGroupChat">保存</el-button>
          </div>
      </el-dialog>
    </div>    
</template>
<script>
import {  add_send_url,update_send_url,list_send_url,del_send_url,list_alarm_config_bind_url,url_bind_alarm_config } from '../../api/alarmManager'
import { getDepartmentTerminalInfoLis,getTerminalInfoByDepId, } from '../../api/energyMG'
import Pagination from '../../components/Pagination'
import PremsButton from "@/views/permission/PreButtom";
import { handleDeletePage} from '../../utils/util.js'

export default {
    components: {
        Pagination,
        PremsButton
    },
    data(){
        return{
            deptData:[],
            visible:false,
            jzProps:{
			    label: function( data,node ){
		        },
			    children: 'deps',
		    },
            getJZ:'',
            tableParam:{
                departmentId:'',
                groupName:'',
                currentPage:1,
                pageSize:10,
                total:0,

            },
            addParam:{
                groupName:'',
                sendMessageUrl:'',
                isEnabled:false,
                departmentId:'',
                id:''
            },
            formVisible:false,
            addTitle:'',
            tableParam:{
                departmentId:'',
                groupName:'',
                isSuccess:false,
                currentPage:1,
                pageSize: 10,
                total: 0,
            },
            saveLoading:false,
            dataList:[],
            loading:false,
            tableHeight:0,
            bindUrlParams:{
                departmentId:'',
                alarmName:'',
                urlId:'',
                isBind:false,//是否绑定
            },
            bindUrlIdParams:{
                urlId:'',
                alarmIdList:[],
                isBind:false,

            },
            bindFormVisible:false,
            bindGroupChatList:[],
            allGroupChatList:[],
            loadBindGroupChat:false,
            groupChatVisible:false,
            urlIdList:[],
            saveBindLoading:false,
            selectGroupList:[],
            unbindLoading:false,
            allgroupLoad:false,
            showPage:true,
            rules: {
                sendMessageUrl :[{ required: true, message: '请输入发送地址',trigger: 'blur' }],
            },


        }
    },
    created(){
        this.getJzData();
    },
    mounted() {
         this.$nextTick(() => {
           this.tableHeight = window.innerHeight - 360
         })
       },
    methods:{
        search(){
            this.tableParam.currentPage = 1
            this.showPage = false;
            this.getTableData();
            this.$nextTick(()=>{
                this.showPage = true;
            })
        },
        // 2023.11.22 表格
        getTableData(){
            this.loading = true;
            list_send_url(this.tableParam).then(res=>{
                this.loading = false;
                if(res.status == 1){
                    this.dataList = res.data.content
                    this.tableParam.total = res.data.totalElements
                    // 地址脱敏处理
                    this.dataList.forEach(item=>{
                        let str1 = item.sendMessageUrl.split('/')
                        // let str2 = str1[1].split('/')
                        console.log( item.sendMessageUrl.split('//'),str1)
                        let str = ''
                        str1.forEach((e,index)=>{
                            
                            // if(index==0){
                            //     if(item=='https:'){
                            //         str+="https:/"
                            //     }else if(item=='http:'){
                            //         str+='http:/'
                            //     }
                                
                            // }else 
                            if(index == 2 && item!=''){
                                str +='*****'
                            }
                            else if(str1.length>1){
                                str+=e+'/'
                            }else{
                                str+=e
                            }

                        })
                        let str2 = str.split('?')
                        let output = ''
                        if(str2[1]){
                            output = str2[0]+"?*****"
                        }else{
                            output = str2[0]
                        }
                        
                        // var output = str.replace(/.(?=.{4})/g, '*');
                        this.$set(item,'sendMessageUrl',output)
                    })
                }

            })

        },
          //2023.11.21获取集中器信息
		getJzData:function(){
				return new Promise((resolve,reject) => {
                    this.loading = true;
					getDepartmentTerminalInfoLis().then(res => {
                       
						if(res.status == 1){
							// let arr = []
							this.deptData = this.changeData(res.data.menuDepList)
                            this.addParam.departmentId = this.deptData[0].id;
                            this.tableParam.departmentId = this.deptData[0].id
                            this.bindUrlParams.departmentId = this.deptData[0].id
                            this.getJZ = this.deptData[0].departmentName
							this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId);
                            this.getTableData();
							resolve()
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

		},
        // 2023.11.20 集中器获取
        getDepIds(id){
        getTerminalInfoByDepId({depId:id}).then(res => {
        	if(res.status == 1){
        		let arr = []
        		res.data.forEach( item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})

        		// this.formInline.terIds = JSON.stringify(arr)

        	}else{
        		this.$message.error(res.msg)
        	}
        })
        },
    //   2023.11.20 部门数据处理
        changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
		},
        // 选择部门
        handleNodeClick(data){
            console.log('data',data)
            this.visible = false
            this.getJZ = data.departmentName
            this.addParam.departmentId = data.id;
            this.tableParam.departmentId = data.id
            this.bindUrlParams.departmentId = data.id
            this.getTableData();
            if(data.isJz){
                let idstr = JSON.stringify([{id:data.id}])
                // this.formInline.terIds = idstr
            // this.search()
            }else{
                //点击部门获得集中器id
                this.getDepIds(data.id);
            }
        },
        // 2023.11.22 点击添加/编辑
        handleGroupChat(row,edit){
            this.formVisible = true;
            if(edit == 'edit'){
            this.addTitle = '编辑';
            this.addParam.groupName = row.groupName,
            this.addParam.sendMessageUrl=row.sendMessageUrl,
            this.addParam.isEnabled=row.isEnabled,
            this.addParam.id=row.id
            }else{
                this.addTitle = '添加'
                this.addParam.groupName = '',
                this.addParam.sendMessageUrl='',
                this.addParam.isEnabled= false,
                this.addParam.id=''
            }
        },
        // 2023.11.22 保存添加、编辑
        saveAddOrEdit(){
            if(this.addTitle == '添加'){
                this.saveLoading = true;
                add_send_url(this.addParam).then(res=>{
                    this.saveLoading = false
                    if(res.status == 1){
                        this.formVisible = false;
                        this.$message.success('添加成功')
                        this.getTableData();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }else{
                this.saveLoading = true;
                update_send_url(this.addParam).then(res=>{
                    this.saveLoading = false
                    if(res.status == 1){
                        this.formVisible = false;
                        this.$message.success('修改成功')
                        this.getTableData();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
            
        },
        // 2023.11.22 删除群聊信息
        deleteGroupChat(row){
           this.$confirm('确定要删除吗?', '信息', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(() => {
            //  this.curId = row.id
            del_send_url({ id:row.id }).then(res => {
                  if(res.status == 1){
                    this.$message.success("删除成功!")
                    // feat:2023.11.21 处理删除完一整页的数据后，实际页码还在当前页问题
                    this.tableParam.currentPage = handleDeletePage(this.tableParam.total, this.tableParam.pageSize, this.tableParam.currentPage)
                    this.getTableData()
                  }else{
                    this.$message.error(res.msg)
                  }
               })
            
         })
        },
        // 2023.11.22 获取绑定数据
        getBindUrlData(isBind){
            this.bindUrlParams.isBind = isBind
            if(isBind){
                this.loadBindGroupChat = true;
            }else{
                this.allgroupLoad = true;
            }  
            // this.bindGroupChatList = [];
            // this.allGroupChatList = [];
            list_alarm_config_bind_url(this.bindUrlParams).then(res=>{
                if(isBind){
                    this.loadBindGroupChat = false;
                }else{
                    this.allgroupLoad = false
                }
                if(res.status == 1){
                    // 已绑定
                    if(isBind){
                        this.bindGroupChatList = res.data;
                    }else{//所有
                        this.allGroupChatList = res.data;
                    }
                }

            })
        },
        // 2023.11.22 分页
        handelPage(param){
            this.tableParam.currentPage = param.currentPage;
            this.tableParam.pageSize = param.pageSize;
            this.getTableData();
        },
        // 2023.11.22 设置
        setGroupChat(row){
            this.bindUrlParams.urlId = row.id;
            this.bindUrlIdParams.urlId = row.id
            this.bindFormVisible = true
            this.getBindUrlData(true);
        },
        //2023.11.22 添加绑定群聊
        handelAddGroupChat(){
            this.urlIdList = [];
            this.groupChatVisible = true;
            this.getBindUrlData(false);

        },
        // 20323.11.23 绑定列表 搜索
        getAllGroupChatList(){
            this.getBindUrlData(false);

        },
        // 2023.11.23勾选绑定id
        getUrlIds(data){
            this.urlIdList = data;
        },
        // 2023.11.23 勾选解绑
        selectUnbind(data){
            this.selectGroupList = data;
        },
        // 2023.11.23 保存绑定
        saveBindGroupChat(){
            this.bindUrlIdParams.alarmIdList = this.urlIdList.map(item => item.id)
            this.bindUrlIdParams.isBind = true;
            this.saveBindLoading = true
            this.bindOrUndind(true)
        },
        // 2023.11.23 绑定或解绑
        bindOrUndind(isBind){
            url_bind_alarm_config(this.bindUrlIdParams).then(res=>{
                if(isBind){
                     this.saveBindLoading = false;
                }else{
                    this.unbindLoading = false;
                } 
                if(res.status == 1){
                    if(isBind){
                        this.groupChatVisible = false;
                        this.$message.success("绑定成功！")
                    }else{
                        this.$message.success("解绑成功！")
                    }
                    this.getBindUrlData(true);
                }else{
                    this.$message.error(res.msg)
                }
            })

        },

        // 2023.11.23 解绑
        removeBindGroupChat(){
            this.bindUrlIdParams.alarmIdList = this.selectGroupList.map(item => item.id)
            this.bindUrlIdParams.isBind = false;
            this.unbindLoading = true
            this.bindOrUndind(false)


        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/alarmManager/groupChatMessage.vue